export default function (coll) {
    return coll[Symbol.iterator] && coll[Symbol.iterator]();
}



// WEBPACK FOOTER //
// ./~/async-es/internal/getIterator.js